import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DiscountTagComponent, TitleSummaryComponent } from '@client-monorepo/common/ui-components';
import { AddressesComponent } from '../addresses/addresses.component';
import { Store, StorePaymentMethod, StoreType, StoreVoucher } from '@client-monorepo/daily-fintech/stores';
import { Router } from '@angular/router';

@Component({
  selector: 'stores-applet-store-intro',
  standalone: true,
  imports: [CommonModule, TitleSummaryComponent, DiscountTagComponent, AddressesComponent],
  templateUrl: './store-intro.component.html',
  styleUrl: './store-intro.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StoreIntroComponent {
  store = input<Store>();
  vouchers = computed<StoreVoucher[] | undefined>(() => {
    if (this.store() && this.store()?.vouchers) {
      return this.store()?.vouchers.filter((item) => !item.expirationDate || item.expirationDate > +new Date());
    }
    return undefined;
  });

  router = inject(Router);

  goToShoppingGuide(): void {
    const paymentMethods = [];
    if (this.store()?.types?.includes(StoreType.ONLINE)) {
      paymentMethods.push('online');
    }
    if (this.store()?.types?.includes(StoreType.ONSITE)) {
      paymentMethods.push('onsite');
    }
    if (this.store()?.paymentMethods?.includes(StorePaymentMethod.QR_CODE)) {
      paymentMethods.push('qr');
    }

    this.router.navigate(['/stores/shopping-guide'], { queryParams: { methods: paymentMethods } });
  }
}
